export default __webpack_public_path__ + "static/media/START_LOCAL.d4400356.png";